import { render, staticRenderFns } from "./OtRoomSetup.vue?vue&type=template&id=2a5be619&scoped=true"
import script from "./OtRoomSetup.vue?vue&type=script&lang=js"
export * from "./OtRoomSetup.vue?vue&type=script&lang=js"
import style0 from "./OtRoomSetup.vue?vue&type=style&index=0&id=2a5be619&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5be619",
  null
  
)

export default component.exports